// extracted by mini-css-extract-plugin
module.exports = {"icon":"EmailButton_icon__UMNt7"};